var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "card-text mb-25" }, [
      _vm._v(
        _vm._s(_vm.tenantData.address) +
          ", " +
          _vm._s(_vm.tenantData.city) +
          " " +
          _vm._s(_vm.tenantData.country)
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }